/**
 * Utility functions for School Year management and formatting
 */

/**
 * Returns formatted Hebrew string representation of a school year string (e.g., '2026-2027' -> 'תשפ"ז (2026-2027)')
 */
export function formatSchoolYearLabel(yearStr: string): string {
  switch (yearStr) {
    case '2026-2027':
      return 'תשפ"ז (2026-2027)'
    case '2025-2026':
      return 'תשפ"ו (2025-2026)'
    case '2024-2025':
      return 'תשפ"ה (2024-2025)'
    case '2027-2028':
      return 'תשפ"ח (2027-2028)'
    default:
      return yearStr
  }
}

/**
 * Calculates start and end YYYY-MM-DD boundaries for a school year string
 */
export function getSchoolYearDateBounds(yearStr: string = '2026-2027'): { startDate: string; endDate: string } {
  const [startYearStr] = yearStr.split('-')
  const startYear = parseInt(startYearStr, 10) || 2026

  return {
    startDate: `${startYear}-09-01`,
    endDate: `${startYear + 1}-08-31`
  }
}

/**
 * Determines current active school year string based on current date (September is start of school year)
 */
export function getCurrentSchoolYear(date: Date = new Date()): string {
  const year = date.getFullYear()
  const month = date.getMonth() + 1 // 1-12
  return month >= 9 ? `${year}-${year + 1}` : `${year - 1}-${year}`
}
